export default __webpack_public_path__ + "static/media/old_logo_iphone_mockup.9bad0844.png";